import { atom } from "jotai";
import { zapIdsAtom } from "./zapIdsAtom";
import {
  ZapErrorObject,
  zapMetadataAtomFamily_SUSPENDS,
} from "./zapAtomFamily_SUSPENDS";
import { ZapMetadata } from "../types";

export const zapsAtom_SUSPENDS = atom(async (get) => {
  const zapIdsFromNodes = get(zapIdsAtom);

  // 'Cuz multiple nodes can have the same zapId
  const uniqueZapIds = new Set(zapIdsFromNodes);

  const zapsPromises = Array.from(uniqueZapIds).map((zapId) =>
    get(zapMetadataAtomFamily_SUSPENDS(zapId)).then((zap) => ({ zapId, zap })),
  );
  const zaps = await Promise.all(zapsPromises);
  return zaps.reduce<Record<string, ZapMetadata>>((acc, { zapId, zap }) => {
    // Check if zap is not null and does not contain an error
    if (zap && !(zap as ZapErrorObject).error) {
      acc[zapId] = zap as ZapMetadata;
    }
    return acc;
  }, {});
});

zapsAtom_SUSPENDS.debugLabel = "zapsAtom_SUSPENDS";
